import Request from './request';

export default class SmsOverageBillingService {
  static async getList({ periodYm, status, search, page = 1, pageSize = 20 } = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: 'admin/billing/sms-overage-history',
        query: Object.fromEntries(
          Object.entries({ periodYm, status, search, page, pageSize })
            .filter(([, v]) => v !== undefined && v !== null && v !== '')
        )
      })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Get SMS overage billing list error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to fetch billing history' }]
          });
        });
    });
  }

  static async getByMerchant(merchantId, { page = 1, pageSize = 20 } = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: `admin/merchants/${merchantId}/sms-overage-history`,
        query: { page, pageSize }
      })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Get merchant SMS overage billing error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to fetch merchant billing history' }]
          });
        });
    });
  }

  static async update(id, { finalAmountCents, status, paymentLink, notes }) {
    return new Promise((resolve) => {
      Request.send({
        method: 'PATCH',
        path: `admin/billing/sms-overage-history/${id}`,
        data: { finalAmountCents, status, paymentLink, notes }
      })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Update SMS overage billing error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to update billing record' }]
          });
        });
    });
  }

  static async generatePeriod(periodYm) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: 'admin/billing/sms-overage-history/generate',
        data: { periodYm }
      })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Generate SMS overage billing error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to generate billing records' }]
          });
        });
    });
  }
}
